export default __webpack_public_path__ + "static/og-image-d09ec0b4ef4f41aa375e309998dc4094.png";